define(
    'LNRS/Components/Charts/base',["jquery", "d3", "scrollMagic", "mustache"],
    function ($, d3, ScrollMagic, mustache) {
        "use strict";

        function Base(scope, chartInfo, id) {

            var self = this;
            var chartId = "#" + id;
            var controller = new ScrollMagic.Controller();
            var scrollTriggerOffset = $(window).height() > 800 ? -150 : 0;
            
            new ScrollMagic.Scene({ triggerElement: chartId, duration: 200, offset: scrollTriggerOffset })
                .on('start', function () {
                    self.animateChart(chartId, chartInfo);
                    this.enabled(false);
                }).addTo(controller);


            Base.prototype.initChart = function initChart(gDiv, dataset) {

            }

            Base.prototype.animateChart = function animateChart(gDiv, dataset) {
          
            }

            Base.prototype.renderLegend = function renderLegend(chartId, chartInfo) {
                if (!chartInfo.legendLabels) return;
                
                var legendContainer = $(chartId).parent().find(".legend");
                var colorIndex = 0;
                var columnIndex = 0;
                var rowIndex = 0;
                var template = '<div class="legend-item"><div class="legend-box" style="background-color: {{color}}"></div>{{label}}</div>';

                $.each(chartInfo.legendLabels, function( index, item ) {
                    if (colorIndex === chartInfo.colors.length) {
                        colorIndex = 0;
                    }
                    var options = {
                        color: chartInfo.colors[colorIndex],
                        label: item
                    };

                    var html = mustache.render(template, options);
                    var columnSelector = ".score-center";

                    if (rowIndex === 0) {
                        $(legendContainer).find(columnSelector).html(html);
                    } else {
                        var existingHtml = $(legendContainer).find(columnSelector).html();
                        $(legendContainer).find(columnSelector).html(existingHtml + html);
                    }
                    
                    rowIndex++;
                    colorIndex++;
                });
            }

            this.initChart(chartId, chartInfo);
            this.renderLegend(chartId, chartInfo);
        }

        return Base;
    });
